import UsersOverviewUI from "@/features/admin/components/Users/overview/users.overview.ui";
import { useUsers } from "@/features/admin/hooks/users/useUsers";
import { Spinner } from "@radix-ui/themes";
import { FC, JSX } from "react";

const UsersOverviewPage: FC = (): JSX.Element => {
  const { data, loading, error } = useUsers();

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (data) {
    return <UsersOverviewUI users={data} />;
  }

  return <UsersOverviewUI />;
};

export default UsersOverviewPage;
